import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isMobileUA } from 'dpl/shared/utils';
import { pushParams, resetParams } from 'dpl/actions/query_params';

import BreedDropdown from './BreedDropdown';
import LocationDropdown from './LocationDropdown';
import { BREED_ID, LOCATION } from '../utils/constants';

const IS_MOBILE_UA = isMobileUA();

export default function SearchSection() {
  const { breedsData, citiesData } = useSelector(({ server }) => server);
  const queryParamBreed = useSelector(
    ({ queryParams }) => queryParams[BREED_ID]
  );
  const queryParamLocation = useSelector(
    ({ queryParams }) => queryParams[LOCATION]
  );

  const [showBreedDropdown, setShowBreedDropdown] = useState(false);
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);

  const [selectedBreed, setSelectedBreed] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const dispatch = useDispatch();

  function getBreedFromId() {
    return breedsData.breeds.find(b => String(b.id) === queryParamBreed);
  }

  function getLocationFromSlug() {
    return citiesData.cities.find(c => c.slug === queryParamLocation);
  }

  useEffect(() => {
    const currentBreed = getBreedFromId();
    setSelectedBreed(currentBreed);

    const currentLocation = getLocationFromSlug();
    setSelectedCity(currentLocation);
  }, [queryParamBreed, queryParamLocation]);

  function handleBreedSelect(breedId) {
    setShowBreedDropdown(false);
    if (!breedId) {
      dispatch(resetParams(BREED_ID));
    } else {
      const breed = breedsData.breeds.filter(
        b => String(b.id) === String(breedId)
      )[0];

      setSelectedBreed(breed);
      dispatch(pushParams({ [BREED_ID]: breed.id }, { hash: true }));
    }
  }

  function handleLocationSelect(cityId) {
    setShowLocationDropdown(false);
    if (!cityId) {
      dispatch(resetParams(LOCATION));
    } else {
      const city = citiesData.cities.filter(
        s => String(s.id) === String(cityId)
      )[0];

      setSelectedCity(city);
      dispatch(pushParams({ [LOCATION]: city.slug }, { hash: true }));
    }
  }

  return (
    <div className="ReviewsSearchSection container-xxl pt12 pb10 pb14-lg">
      <div className="row h-100 flex justify-center">
        <h4 className="font-24 lg:font-32 tc w-100">
          Show me owner stories for {IS_MOBILE_UA ? <br /> : ' '}
          <button
            type="button"
            className="blue-500 underline"
            onClick={() => {
              setShowLocationDropdown(false);
              setShowBreedDropdown(true);
            }}
          >
            {selectedBreed ? selectedBreed.pluralized_name : 'select breed'}
          </button>
          {!IS_MOBILE_UA ? <br /> : ' '}
          in
          {IS_MOBILE_UA ? <br /> : ' '}
          <button
            type="button"
            className="blue-500 underline"
            onClick={() => {
              setShowBreedDropdown(false);
              setShowLocationDropdown(true);
            }}
          >
            {selectedCity ? selectedCity.name : 'select location'}
          </button>
        </h4>
        {showBreedDropdown && (
          <BreedDropdown
            handleBreedSelect={handleBreedSelect}
            breedOptions={breedsData.breeds}
            selectedBreedId={selectedBreed?.id}
            closeDropdown={() => setShowBreedDropdown(false)}
            isVisible={showBreedDropdown}
          />
        )}
        {showLocationDropdown && (
          <LocationDropdown
            handleLocationSelect={handleLocationSelect}
            locationOptions={citiesData.cities}
            selectedLocationId={selectedCity?.id}
            closeDropdown={() => setShowLocationDropdown(false)}
            isVisible={showLocationDropdown}
          />
        )}
      </div>
    </div>
  );
}
